/**
 * 全局常量集合
 */

/** 性能调试开关：非生产环境开启，所有性能调试相关代码用此变量守卫 */
export const PERF_DEBUG = process.env.NUXT_APP_ENV !== 'production'

/** TECH002 官网地址 */
// export const TECH002 = 'interface003.com'
export const TECH002 = 'tech002.com'
export const WIKIBITWEBV1 = 'wikibitweb-v1'
export const CLIENT_ID = `GACQKnIBtNhlUp3M4mQbglXws6DgXjtC`
export const CLIENT_SECRET = `NO9HD3Nq38iCRq47QAIB1uCryP2fsWpK`
